module.exports = __webpack_public_path__ + "img/symbol_7.05445c32.png";